





































import {Component, Mixins} from 'vue-property-decorator'
import {Getter} from 'vuex-class'
import {$, PageCollection, pushByName, success} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import {MixinSelect} from '@/components/mixins/MixinSelect'
import {AppConfig} from '@/config/app.config'
import Responsavel from '@/model/resource/Responsavel'
import EmailAuditoria from '@/model/resource/EmailAuditoria'
import ModalAuditAutomaticNotification from '@/components/modals/ModalAuditAutomaticNotification.vue'
import {Role} from '../../enums/Role'

const metaInfo = () => ({
  title: $.t('view.manage.auditEmail.title'),
})

@Component({
  components: {ModalAuditAutomaticNotification},
  metaInfo,
})
export default class ManageAuditEmailListView extends Mixins(MixinFilter, MixinSelect) {
  @Getter('auth/responsavel') user!: Responsavel
  @Getter('auth/role') role!: Role

  Role = Role
  AppConfig = AppConfig
  pushByName = pushByName

  collection = new PageCollection(EmailAuditoria, {}, 10)

  openAuditAutomaticNotification() {
    $.modal.open('auditAutomaticNotification')
  }

}
